import axios from "axios";

const mpVerifyPayment = async ({ paymentId }) => {
  try {
    const { data } = await axios.post(`/mercadopago/verify/payment`, {
      paymentId: paymentId,
    });

    if (!data?.success) throw new Error();

    return {
      success: true,
      message: "Sucesso ao verificar informações do pagamento",
      status: data?.status,
    };
  } catch (error) {
    return {
      success: false,
      message: "Erro ao verificar informações do pagamento",
    };
  }
};

export { mpVerifyPayment };
